/**
 * @generated SignedSource<<dfefedeabf31e3117ca23383257f7dec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespUnavailableHeader_item$data = {
  readonly isSold: boolean | null;
  readonly photos: ReadonlyArray<{
    readonly smallPath: string | null;
  } | null> | null;
  readonly seller: {
    readonly isAccessible: boolean | null;
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_item" | "SharedGateViewPrice_item" | "useGateSoldPrice_item">;
  readonly " $fragmentType": "PdpRespUnavailableHeader_item";
};
export type PdpRespUnavailableHeader_item$key = {
  readonly " $data"?: PdpRespUnavailableHeader_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespUnavailableHeader_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespUnavailableHeader_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedGateViewPrice_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGateSoldPrice_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAccessible",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "08c7434a703843fccb8cdeacd2975ccf";

export default node;
